
<template>
    <v-container fluid>
      <div class="base-title" style="margin-bottom: 10px">
        <h2>Mapping</h2>
      </div>
       <v-tabs
         v-model="selectedTab"
      >
        <v-tab
            v-for="view in views"
            :key="view"
            @click="goTo(view)"
          >
            {{ view }}
          </v-tab>
      </v-tabs>
      <app-mapping 
        :mappingSpecs="mappingSpecs"
      />
    </v-container>
</template>


<script>
  import Mapping from './Mapping.vue'
  export default {
    props: ['mappingType'],
    components: {
      AppMapping : Mapping,
      
    },
    data(){
      return {
        views: ['inventory', 'order'],
        selectedTab : 0
      }
    },
    methods: {
      goTo(view){
        this.$router.push('/mapping/'+view)
      }
    },
    created(){
      if(this.mappingType == "order"){
        this.selectedTab = 1
      }
    },
    computed : {
      mappingSpecs(){
        const mappingType = this.mappingType == undefined ? "inventory" : this.mappingType
        return {
          apiEndPoint: 'mapping/'+mappingType+'Mapping',
          type: {
            name: mappingType == "inventory" ? 'adUnitName' : 'orderName',
            classification: 'reportingId'
          }
        }
      }
    }
  }
</script>